// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/sharing_code_kind.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/sharing_code_kind.proto.
 */
export const file_studyo_today_planners_v1_resources_sharing_code_kind = /*@__PURE__*/
  fileDesc("CjpzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3NoYXJpbmdfY29kZV9raW5kLnByb3RvEiJzdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzKqwBCg9TaGFyaW5nQ29kZUtpbmQSIQodU0hBUklOR19DT0RFX0tJTkRfVU5TUEVDSUZJRUQQABIgChxTSEFSSU5HX0NPREVfS0lORF9JTlZJVEFUSU9OEAESIwofU0hBUklOR19DT0RFX0tJTkRfUEFSVElDSVBBVElPThACEi8KK1NIQVJJTkdfQ09ERV9LSU5EX1NDSEVEVUxFX0NZQ0xFX0lOVklUQVRJT04QA0IqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.planners.v1.resources.SharingCodeKind.
 */
export const SharingCodeKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_sharing_code_kind, 0);

/**
 * Sharing code kind
 *
 * @generated from enum studyo.today.planners.v1.resources.SharingCodeKind
 */
export const SharingCodeKind = /*@__PURE__*/
  tsEnum(SharingCodeKindSchema);

